// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import SleepDashboard from './pages/SleepDashboard';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(<SleepDashboard />);

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Dashboard from './pages/Dashboard';
import { Amplify } from 'aws-amplify';
import { buildAwsConfig } from './aws-config';

// Configure AWS Amplify.
// buildAwsConfig() returns null if window.APP_CONFIG is not yet available (e.g. env-config.js
// was missing or failed to load). In that case we log an error but still let React render
// so the user sees a proper page instead of a completely blank screen.
// The root cause of the missing config should be investigated in start.sh / SSM logs.
const awsConfig = buildAwsConfig();
if (awsConfig) {
  Amplify.configure(awsConfig);
} else {
  console.error(
    'Amplify not configured - env-config.js may be missing or empty. ' +
    'On cloud: check that start.sh ran successfully and fetched SSM parameters. ' +
    'On local: check that frontend/.env file exists with REACT_APP_* values.'
  );
}

// Prevent React error overlay from showing for expected API errors
// This handles unhandled promise rejections that would otherwise show the red error screen
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    
    // Check if this is an expected API error (404, network errors, etc.)
    if (error && (
      error.status === 404 ||
      error.isNotFound ||
      (error.message && (
        error.message.includes('HTTP 404') ||
        error.message.includes('HTTP 5') ||
        error.message.includes('No data found') ||
        error.message.includes('Resident not found') ||
        error.message.includes('Network error') ||
        error.message.includes('Failed to fetch') ||
        error.message.includes('NetworkError') ||
        error.message.includes('Request timed out')
      ))
    )) {
      // Prevent the error overlay from showing
      event.preventDefault();
      // Log as warning instead
      console.warn('[Expected API Error - Handled by component]:', error.message || error);
      return;
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Dashboard />);
